import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value"]

import { ref, computed, watch, reactive, onMounted } from 'vue';
import * as service from '@/services/clientesContratosService';

interface Props {
  modelValue?: number
  placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownContratosStatus',
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ['update:modelValue', 'selected'],
  setup(__props: any, { emit: __emit }) {

var props = __props;
const emit = __emit


var controle = reactive({
  items: [] as service.ContratoStatus[],
  id: null as number | null,
  text: "",
  status: ""
})

onMounted(() => {
  buscarItens()
})



function selecionar() {

  var status =   controle.items.find(c => c.statusId === controle.id)
  if (status) {
    emit('update:modelValue', status.statusId)
    emit('selected', status)
  }
  else {
    emit('update:modelValue', null)
    emit('selected', null)
  }
}


// Watch para sincronizar com modelValue externo
watch<number | undefined>(() => props.modelValue, (newValue) => {
  controle.id = newValue ?? null;
})


function buscarItens() {
  controle.status = "Buscando...";

  service.obterStatus().then(response => {
    controle.items = response;
    controle.status = "";
  }).catch(error => {
    console.error("Erro ao buscar itens:", error);
    controle.status = `Erro ${error.message}`;
  })
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).id) = $event)),
    class: "form-select form-select-sm",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (selecionar()))
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("option", { value: null }, "- Selecione -", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).items, (item) => {
      return (_openBlock(), _createElementBlock("option", {
        key: item.statusId,
        value: item.statusId
      }, _toDisplayString(item.descricao), 9, _hoisted_1))
    }), 128))
  ], 544)), [
    [_vModelSelect, _unref(controle).id]
  ])
}
}

})